var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb-icon no-shrink",class:{
    active: _vm.active,
    pointer: _vm.pointer,
  },style:(_vm.wrapperVars),on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"hover-background"}),_c('span',{staticClass:"icon",class:[_vm.icon.cssClass, {mask: _vm.mask, 'mask-hover': _vm.maskHover, spin: _vm.spin}],style:(_vm.cssVars)}),(_vm.counter)?[_c('div',{staticClass:"counter"},[_vm._v("\n      "+_vm._s(_vm.counter)+"\n    ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }